import { Box, Typography } from "@mui/material";
import React from "react";
import { Oval } from "react-loader-spinner";
import theme from "../../Theme/Theme";

export const InlineLoader = (props) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(25, 118, 210, 0.95)",
        borderRadius: "12px",
        padding: "24px",
        boxShadow: "0 8px 32px rgba(25, 118, 210, 0.3)",
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        minHeight: "120px",
        minWidth: "200px",
        transition: "all 0.3s ease",
      }}
    >
      <Oval
        visible={true}
        secondaryColor="rgba(255, 255, 255, 0.3)"
        width="32"
        height="32"
        color="white"
        ariaLabel="loading"
      />
      <Typography 
        variant="body2" 
        sx={{ 
          marginTop: 2, 
          color: "white", 
          fontSize: "14px",
          fontWeight: 600,
          textAlign: "center",
          letterSpacing: "0.5px"
        }}
      >
        {props.message || "Loading..."}
      </Typography>
    </Box>
  );
}; 